import { BarOne, BarThree, BarTwo, Container } from './styled';
export function LoadingBars(props) {
    const { size } = props;
    return (<Container $size={size}>
      <BarOne $size={size}/>
      <BarTwo $size={size}/>
      <BarThree $size={size}/>
    </Container>);
}
